var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcLogoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#14AFF1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H48V48H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M45.2,4H6.8A4.617,4.617,0,0,0,2.024,8.495L2,35.464a4.639,4.639,0,0,0,4.8,4.495H45.2A4.639,4.639,0,0,0,50,35.464V8.495A4.639,4.639,0,0,0,45.2,4Zm0,31.464H6.8V21.277H45.2Zm0-22.474H6.8V8.495H45.2Z",
    transform: "translate(-2 2.317)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcLogoBlue);
export default __webpack_public_path__ + "static/media/cc-logo-blue.67959681a5199000a60113175181cbda.svg";
export { ForwardRef as ReactComponent };